import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=4653bff4&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=4653bff4&prod&scoped=true&lang=scss"
import style1 from "./Navigation.vue?vue&type=style&index=1&id=4653bff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4653bff4",
  null
  
)

export default component.exports